//Style
import '../../styles/cv/card.scss'

//Images
import TravelIcon from '../../assets/cv_travel_icon.svg'
import SpeakIcon from '../../assets/cv_speak_icon.svg'
import DrawingIcon from '../../assets/cv_drawing_icon.svg'
import JournalingIcon from '../../assets/cv_journaling_icon.svg'
import SunIcon from '../../assets/cv_sun_icon.svg'

// Language
import { useLanguage } from '../../context/language_context'


function Competences() {

    const { language } = useLanguage()

    return (

        <div className='cv_card_details'>


            {/* SOFTWARE SKILLS */}

            <div className='cv_card_title cv_card_skills'>

                <h3>
                    {language === 'fr'
                        ? 'Compétences en logiciel'
                        : 'Software skills'}
                </h3>

                <ul>

                    <li>
                        <progress
                            id="software_social"
                            max="100"
                            value="100"
                        />

                        <label htmlFor="software_social">
                            {language === 'fr'
                                ? 'Réseaux sociaux : Discord, TikTok, YouTube, Instagram, Reddit, Twitch'
                                : 'Social media: Discord, TikTok, YouTube, Instagram, Reddit, Twitch'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="software_online"
                            max="100"
                            value="95"
                        />

                        <label htmlFor="software_online">
                            {language === 'fr'
                                ? 'Outils en ligne : Canva, Trello, Notion, Figma, Toggl, Google Workspace'
                                : 'Online tools: Canva, Trello, Notion, Figma, Toggl, Google Workspace'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="software_video"
                            max="100"
                            value="90"
                        />

                        <label htmlFor="software_video">
                            {language === 'fr'
                                ? 'Montage vidéo : Capcut, Premiere Pro, TikTok'
                                : 'Video editing: Capcut, Premiere Pro, TikTok'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="software_analytics"
                            max="100"
                            value="85"
                        />

                        <label htmlFor="software_analytics">
                            {language === 'fr'
                                ? "Outils d'analyse et de campagne digitale : Google Ads, Meta Ads, Google Analytics"
                                : 'Analytics and digital campaign tools: Google Ads, Meta Ads, Google Analytics'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="software_adobe"
                            max="100"
                            value="80"
                        />

                        <label htmlFor="software_adobe">
                            {language === 'fr'
                                ? 'Suite Adobe : Photoshop, InDesign, Premiere Pro, Illustrator'
                                : 'Adobe Creative Suite: Photoshop, InDesign, Premiere Pro, Illustrator'}
                        </label>
                    </li>

                </ul>

            </div>


            {/* SOFT SKILLS */}

            <div className='cv_card_title cv_card_skills'>

                <h3>
                    {language === 'fr'
                        ? 'Compétences humaines'
                        : 'Soft skills'}
                </h3>

                <ul>

                    <li>
                        <progress
                            id="soft_creativity"
                            max="100"
                            value="100"
                        />

                        <label htmlFor="soft_creativity">
                            {language === 'fr'
                                ? 'Créativité, autonomie, polyvalence, curiosité, sens du détail'
                                : 'Creativity, autonomy, versatility, curiosity, attention to detail'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="soft_project"
                            max="100"
                            value="95"
                        />

                        <label htmlFor="soft_project">
                            {language === 'fr'
                                ? 'Gestion de projet, adaptabilité, communication interculturelle'
                                : 'Project management, adaptability, cross-cultural communication'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="soft_leadership"
                            max="100"
                            value="85"
                        />

                        <label htmlFor="soft_leadership">
                            {language === 'fr'
                                ? "Leadership, esprit d'initiative, persévérance"
                                : 'Leadership, initiative, perseverance'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="soft_customer"
                            max="100"
                            value="75"
                        />

                        <label htmlFor="soft_customer">
                            {language === 'fr'
                                ? 'Relation clients, logistique'
                                : 'Customer relations, logistics'}
                        </label>
                    </li>

                </ul>

            </div>


            {/* HOBBIES */}

            <div className='cv_card_hobbies'>

                <h3>
                    {language === 'fr'
                        ? 'Loisirs'
                        : 'Hobbies'}
                </h3>

                <ul>

                    <li>
                        <img src={TravelIcon} alt="" />

                        {language === 'fr'
                            ? 'voyages, particulièrement en Asie'
                            : 'travel, particularly in Asia'}
                    </li>


                    <li>
                        <img src={SpeakIcon} alt="" />

                        {language === 'fr'
                            ? 'apprentissage de langues'
                            : 'language learning'}
                    </li>


                    <li>
                        <img src={DrawingIcon} alt="" />

                        {language === 'fr'
                            ? 'UI design et dessin'
                            : 'UI design and illustration'}
                    </li>


                    <li>
                        <img src={JournalingIcon} alt="" />

                        {language === 'fr'
                            ? 'journaling et écriture'
                            : 'journaling and writing'}
                    </li>

                </ul>

            </div>


            {/* OBJECTIVES */}

            <div className='cv_card_objectives'>

                <h3>
                    {language === 'fr'
                        ? 'Objectifs'
                        : 'Goals'}
                </h3>

                <ul>

                    <li>
                        <img src={SunIcon} alt="" />

                        {language === 'fr'
                            ? 'Publier une exposition avec Moonloading'
                            : 'Organize an exhibition with Moonloading'}
                    </li>


                    <li>
                        <img src={SunIcon} alt="" />

                        {language === 'fr'
                            ? 'Obtenir le TOPIK 5 en coréen'
                            : 'Achieve TOPIK level 5 in Korean'}
                    </li>

                </ul>

            </div>

        </div>

    )
}

export default Competences